module.exports = __webpack_public_path__ + "img/size4.809f561e.png";